module.exports = __webpack_public_path__ + "img/34.3a69a150.webp";